// Types of Login
export const REGISTER_USER = "REGISTER_USER";
export const SIGNIN_USER = "SIGNIN_USER";
export const UPDATE_USER = "UPDATE_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const CHECK_EMAIL = "CHECK_EMAIL";
export const MIDDLEWARE_OFF = "MIDDLEWARE_OFF";
export const MIDDLEWARE_ON = "MIDDLEWARE_ON";
export const ADD_DASHBOARD_NAME = "ADD_DASHBOARD_NAME";

// Types of Add Product
export const FETCH_PARENT_CATEGORY = "FETCH_PARENT_CATEGORY";
export const FETCH_ALL_CATEGORY = "FETCH_ALL_CATEGORY";
export const FETCHING_ALL_CATEGORY = "FETCHING_ALL_CATEGORY";
export const FETCH_CHILD_CATEGORY = "FETCH_CHILD_CATEGORY";
export const CREATE_PARENT_CATEGORY = "CREATE_PARENT_CATEGORY";
export const CREATE_CHILD_CATEGORY = "CREATE_CHILD_CATEGORY";
export const FETCH_BRAND = "FETCH_BRAND";
export const FETCH_BRAND_BY_CATEGORY = "FETCH_BRAND_BY_CATEGORY";
export const CREATE_BRAND = "CREATE_BRAND";
export const FETCH_FEATURE_LIST = "FETCH_FEATURE_LIST";
export const CREATE_BRAND_BY_CATEGORY = "CREATE_BRAND_BY_CATEGORY";
export const CREATE_FEATURE = "CREATE_FEATURE";
export const CREATE_FEATURE_VALUE = "CREATE_FEATURE_VALUE";
export const CREATE_VARIANT = "CREATE_VARIANT";
export const CREATE_VARIANT_VALUE = "CREATE_VARIANT_VALUE";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const FETCH_VARIANT = "FETCH_VARIANT";
export const ADD_VARIANT_NAME = "ADD_VARIANT_NAME";
export const FETCH_PRODUCT_BY_ID = "FETCH_PRODUCT_BY_ID";
export const FETCH_VARIANT_IMGS = "FETCH_VARIANT_IMGS";

// Types of Products
export const FETCH_ACTIVE_PRODUCTS = "FETCH_ACTIVE_PRODUCTS";
export const FETCHING_ACTIVE_PRODUCTS = "FETCHING_ACTIVE_PRODUCTS";
export const ADD_VENDOR_VARIANT = "ADD_VENDOR_VARIANT";
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const ADD_PRICING = "ADD_PRICING";
export const FETCH_PRICING = "FETCH_PRICING";
export const UPDATE_PRICING = "UPDATE_PRICING";

// Types of Listed Product
export const FETCH_ALL_BRANDS = "FETCH_ALL_BRANDS";
export const FETCH_ALL_CHILD_CATEGORY = "FETCH_ALL_CHILD_CATEGORY";
export const LOADING_FETCH_ALL_BRANDS = "LOADING_FETCH_ALL_BRANDS";
export const LOADING_FETCH_ALL_CHILD_CATEGORY =
  "LOADING_FETCH_ALL_CHILD_CATEGORY";

// Types for Image Upload
export const UPLOADING_CATEGORY_IMG = "UPLOADING_CATEGORY_IMG";
export const UPLOADED_CATEGORY_IMG = "UPLOADED_CATEGORY_IMG";
export const UPLOADING_BRAND_IMG = "UPLOADING_BRAND_IMG";
export const UPLOADED_BRAND_IMG = "UPLOADED_BRAND_IMG";
export const UPDATING_BRAND = "UPDATING_BRAND";
export const UPDATED_BRAND = "UPDATED_BRAND";
export const UPDATING_CATEGORY = "UPDATING_CATEGORY";
export const UPDATED_CATEGORY = "UPDATED_CATEGORY";
export const REMOVING_BRAND = "REMOVING_BRAND";
export const REMOVED_BRAND = "REMOVED_BRAND";
export const REMOVING_CATEGORY = "REMOVING_CATEGORY";
export const REMOVED_CATEGORY = "REMOVED_CATEGORY";
// Types for Orders
export const FETCHING_ORDER = "FETCHING_ORDER";
export const ORDER_FETCHED = "ORDER_FETCHED";
export const FETCHING_ALL_ORDERS = "FETCHING_ALL_ORDERS";
export const ALL_ORDERS_FETCHED = "ALL_ORDERS_FETCHED";
export const ORDER_UPDATION = "ORDER_UPDATION";
export const ORDERS_UPDATED = "ORDERS_UPDATED";
export const FETCHING_ORDER_STATUES = "FETCHING_ORDER_STATUES";
export const ORDER_STATUS_FETCHED = "ORDER_STATUS_FETCHED";
export const FETCHING_ORDER_PAYTYPE = "FETCHING_ORDER_PAYTYPE";
export const ORDER_PAYTYPE_FETCHED = "ORDER_PAYTYPE_FETCHED";
export const UPDATING_ORDER_STATUS = "UPDATING_ORDER_STATUS";
export const ORDER_STATUS_UPDATED = "ORDER_STATUS_UPDATED";
export const SELECTED_VARIANT = "SELECTED_VARIANT";
export const FETCH_VARIANT_V2 = "FETCH_VARIANT_V2";
export const FETCH_FEATURE_VARIANT_LIST = "FETCH_FEATURE_VARIANT_LIST";
export const RESET_ADD_PRODUCT_FLOW = "RESET_ADD_PRODUCT_FLOW";

// Types of Pricing
export const FETCH_PRICING_CONFIGS = "FETCH_PRICING_CONFIGS";
export const FETCH_PRICING_CONFIG = "FETCH_PRICING_CONFIG";
export const FETCH_VARIANT_PRICING_CONTEXT = "FETCH_VARIANT_PRICING_CONTEXT";
export const FETCH_PRICING_ANALYTICS = "FETCH_PRICING_ANALYTICS";
export const FETCH_PRICING_MAPS = "FETCH_PRICING_MAPS";
export const FETCH_PRICING_LOADING = "FETCH_PRICING_LOADING";
